'use client';

import { Lock } from 'lucide-react';
import Button from '@/components/ui/Button';
import { promptLoginAndReturn } from '@/features/jobs/hooks/useGuestGate';

export default function GuestLimitNotice({ message }: { message: string }) {
  return (
    <div className="flex flex-col items-center gap-3 p-6 text-center">
      <Lock size={48} className="text-gray-400" />
      <p className="text-sm font-medium text-gray-600">{message}</p>
      <Button variant="primary" onClick={promptLoginAndReturn}>
        Нэвтрэх
      </Button>
    </div>
  );
}
